var shouldShowEmployerMapping = function (props) {
    return props.loadedEmployer &&
        !props.loadedPlatform.isEmployer &&
        props.loadedPlatform.name.trim().toLowerCase() !==
            props.loadedEmployer.name.trim().toLowerCase();
};
export default shouldShowEmployerMapping;
